import { bootstrapApplication } from "@angular/platform-browser";
import { AppComponent } from "./app/app.component";
import { appConfig } from "./app/app.config";
import { environment } from "./environments/environment";

if (environment.production) {
  // eslint-disable-next-line @typescript-eslint/no-var-requires
}

bootstrapApplication(AppComponent, appConfig).catch((err) =>
  console.error(err),
);
